import { all, Div, H3, reactive, Span, VArray } from 'alkali'
import Dropdown from 'components/generic/Dropdown'
import { fixCasing, analyzeTreatmentAs, analyzeAsSubscript, getInitialLetter } from 'model/SearchQuery'
import * as closeIcon from 'icons/close.svg'
import * as controlIcon from 'icons/pill.svg'
import * as doseComparisonIcon from 'icons/legal-scale-unequal.svg'
import Icon from 'components/Icon'
import {GroupNamingDialog} from 'components/filter/GroupNamingDialog'

let interventionCollections = analyzeTreatmentAs.to(analyzeTreatmentMap => {
	let treatments = ['Control']
	for (let [ id, label ] of analyzeTreatmentMap) {
		if (!treatments.includes(label)) {
			treatments.push(label)
		}
	}
	for (let [ label ] of analyzeAsSubscript) {
		if (!treatments.includes(label)) {
			treatments.push(label)
		}
	}
	return treatments
}).as(VArray)

export class InterventionDropdown extends Dropdown.with('.intervention-dropdown') {
	ready({ selected, allowSelected, allowUnselect }) {
		this.items = all([selected, interventionCollections], (selected, collections) => {
			return [
				new H3('.compare-as', { isHeader: true }, [
					this.selected.to(selected => 'Group ' + selected + ' with:')])
				].concat(((selected && !collections.includes(selected) && allowSelected) ? [selected] : []).concat(collections).map(intervention => ({
				content: Div([Span('.selector-checkbox.selector-selected', {
					content: renderInitial(intervention),
					title: 'Intervention group ' + intervention,
				}), ...(intervention == selected ?
					 [intervention] :
					 [Span('.primary-attribute-label', [intervention])]
					 )]),
				onclick: () => {
					this.onSelection(intervention)
				}
			}))).concat([
			{
				content: Div([Span('.selector-checkbox.selector-selected', ['+']), 'New intervention group']),
				onclick: () => {
					let newCollection
					new GroupNamingDialog({ 
						type: 'intervention',
						// Intervention we intend to group this new group with
						groupWith: selected,
						onName: (newName) => {
							newCollection = fixCasing(newName)
							interventionCollections.push(newCollection)
							this.onSelection(newCollection)
							analyzeTreatmentAs.updated()
						}
					}).show()
				}
			},/* { // TODO: Add this when we do EV-686
				content: Div([Span('.selector-checkbox.selector-selected', [Icon({ icon: doseComparisonIcon })]), 'Compare ' + selected + ' dosage']),
				onclick: () => {
					this.onSelection(selected)
					//analyzeTreatmentAs.updated()
				}
			},*/]).concat(allowUnselect ? [{
				content: Div([Icon({ icon: closeIcon }), 'Unselect treatment']),
				onclick: () => {
					this.onSelection(null)
				}
			}] : [])
		}).as(VArray)
	}
	position({ offsetLeft, offsetTop, clientWidth }) {
		super.position({ offsetLeft, offsetTop: offsetTop + 20, clientWidth })
	}
}

export const renderInitial = (analyzeAs, generateNew) => {
	if (!analyzeAs)
		return null
	if (analyzeAs == 'Control')
		return [ Icon({ icon: controlIcon }) ]
	let initialLetter = analyzeAs[0].toUpperCase()
	let subscript = analyzeAsSubscript.get(analyzeAs)
	if (!subscript && generateNew) {
		subscript = getInitialLetter(analyzeAs)
	}
	if (subscript > 1) {
		return [ initialLetter, Span('.analyze-subscript', [ subscript ]) ]
	}
	return [ initialLetter ]
}
